import { AccountIcon } from './AccountIcon';

/**
 * author: Google
 * id E76EC23F-AB71-49B3-9173-841544527A20
 * name account
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account.svg
 * tags
 * - Account / User 
 * - Home Automation 
 */
export const UserIcon = AccountIcon;
export default UserIcon